import { api } from "./client";

export interface AccountInfo {
  id: string;
  name: string;
  email?: string;
  [key: string]: unknown;
}

export const accountApi = {
  getInfo: () =>
    api.get<{ data: AccountInfo }>("/account"),
};
